import React from 'react';
import { PortailEntrepriseBase } from '../components/entreprise/PortailEntrepriseBase';

export default function PortailClientPage() {
  return <PortailEntrepriseBase mode="entreprise" />;
}
